// useApi.js
import { useState } from "react";
import axios from "axios";


const useApi = () => {
  const apiUrl = process.env.REACT_APP_NEW_API_URL || "http://localhost:8080"; // Replace with your API URL
  // console.log(apiUrl);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const get = async (endpoint) => {
    try {
      const response = await axios.get(`${apiUrl}/${endpoint}`);
      return response;
    } catch (error) {
      console.error(error);

      return error;
    }
  };

  const postTemp = async (endpoint, data) => {
    try {
      const response = await axios.post(
        `http://localhost:8080/${endpoint}`,
        data,
      );
      return response;
    } catch (error) {
      console.error(error);
      return error;
    }
  };

  const post = async (endpoint, data, config = {}) => {
    try {
      const response = await axios.post(`${apiUrl}/${endpoint}`, data, config);
      return response;
    } catch (error) {
      console.error(error);
      return error;
    }
  };

  const put = async (endpoint, data) => {
    try {
      const response = await axios.put(`${apiUrl}/${endpoint}`, data);
      return response;
    } catch (error) {
      console.error(error);
      return error;
    }
  };

  const deleteApi = async (endpoint) => {
    try {
      const response = await axios.delete(`${apiUrl}/${endpoint}`);
      return response;
    } catch (error) {
      console.error(error);
      return error;
    }
  };

  return { get, post, postTemp, put, deleteApi, data, error, loading };
};

export default useApi;
